module.exports = __webpack_public_path__ + "img/182.c714e527.jpg";